// extracted by mini-css-extract-plugin
export default {"root":"H1BjoVAnVk","name":"pQlf4Du65c","icon":"o3E2MqoQ0L"};